
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },
        {
  hid: 'description',
  name: 'description',
  content: 'Experience the luxury of a private yacht in Goa, where you can unwind with stunning views, gourmet cuisine, and personalized service for an exclusive getaway on the water. Perfect for intimate gatherings and special occasions.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Explore the finest private yacht offerings in Goa, featuring breathtaking sunsets, exquisite dining options, and a serene ambiance ideal for creating unforgettable memories with your loved ones.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Embark on an exclusive journey aboard a private yacht in Goa, where you can enjoy tailored experiences, gourmet meals, and breathtaking views. Ideal for romantic escapes or family celebrations!',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'private yacht goa, party private yacht goa, private yacht goa price, goa private yacht rental, goa private yacht booking, goa yacht - water sports in goa',
        },
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Scenic Locations",
      text: "Enjoy breathtaking views of Goa's coastline and rivers with our boat cruises!",
    },
    {
      title: "Fun for Everyone",
      text: "Whether it's a family trip or a romantic outing, there's a boat cruise for every occasion!",
    },
    {
      title: "Expert Crew",
      text: "Our friendly and experienced crew ensures you have a safe and memorable journey.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect boat cruise effortlessly through the Goa App at great rates!",
    },
  ],

      title: 'Private Yacht in Goa - Private Yacht in Goa Price',
    };
  },
  
  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/private-yacht-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/private-yacht-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/private-yacht-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Private Yacht Goa",
  "description": "Experience a Private Yacht in Goa with scenic views, delicious meals, and live entertainment, perfect for a memorable evening.",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
 "offers": {
  "@type": "Offer",
  "price": "Varies based on season and package",
  "priceValidUntil": "2025-12-31",
  "priceCurrency": "INR",
  "availability": "InStock",
  "seller": {
    "@type": "Organization",
    "name": "Goa App"
  }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/private-yacht-goa",
        "url": "https://www.goa.app/private-yacht-goa",
        "name": "Private Yacht Goa ",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-07-31T18%3A39%3A15.979Zmajesty-66-cover-64c7ff0f21f19.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=SBQeZOQJ%2BLspQ%2BRBQ%2FUS2gy3NOUXHpHwiMtYAdA5T6iYYEE7Q%2FevrFemKcZW3S17fHA0kUA9UCzI4UI2YZXhulszRR9sID0hz4Fle87TyO6nRA9yYjy3KpIv6%2BO2ThbHH%2F0syQT1J3e9vQrEoAfOY6Q11KezC608eIrJ7gD%2BfhevJcwrdQXgPrkSTf6L5oLe29OQF48VvNbUc%2FPorfe6wnfZxyMQpzWYNBvtd9fLzUvuSkuF9c9wLa%2FihU1ibDaq9rCRoGdM%2FhEjkWzGBDgHxRjSjcMYSOY6uMFHkjwrd4gUGqmuPp5csRc2Bz7L7O92zxaX25F8694pIqWjNvmBsw%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Private Yacht in Goa offers a memorable experience with scenic views, lively entertainment, and great vibes. Ideal for celebrations or special occasions, these cruises let you enjoy Goa’s beauty and vibrant atmosphere while partying along its rivers or coastline.",
        "breadcrumb": {
            "@id": "https://www.goa.app/private-yacht-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/private-yacht-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
  "@type": "Question",
  "name": "How do I book a private yacht in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "You can book a private yacht in Goa through various online platforms or by contacting local operators. Booking in advance, especially during peak season, is recommended to secure your yacht."
  }
},
{
  "@type": "Question",
  "name": "What is included in a private yacht rental package?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Private yacht rental packages in Goa typically include the yacht, crew, and basic amenities. Some packages offer extras like meals, beverages, and water sports activities."
  }
},
{
  "@type": "Question",
  "name": "What should I wear for a private yacht experience in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "It’s recommended to wear comfortable, smart casual attire. Avoid high heels and dress for the weather. Don’t forget your swimwear if you plan to take a dip or engage in water sports."
  }
},
{
  "@type": "Question",
  "name": "How long can I rent a private yacht in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yacht rentals in Goa can last anywhere from a few hours to a full day, depending on the package. Longer rentals for special occasions can be arranged with the yacht operator."
  }
},
{
  "@type": "Question",
  "name": "Can I customize the experience on a private yacht in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many operators allow customization for special occasions such as birthdays, weddings, or corporate events. You can add elements like decorations, personalized meals, and entertainment."
  }
},
{
  "@type": "Question",
  "name": "Are meals and drinks included in the private yacht rental?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some private yacht rentals include meals and drinks, while others may offer them as an optional add-on. It's best to confirm with the yacht provider when booking."
  }
},
{
  "@type": "Question",
  "name": "What is the price range for private yacht rentals in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Prices for private yacht rentals in Goa typically start from ₹10,000 and can go up to ₹1 lakh or more, depending on the yacht’s size, duration of the rental, and included services."
  }
},
{
  "@type": "Question",
  "name": "Can I book a private yacht for a special occasion?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, private yachts are perfect for special occasions like anniversaries, birthdays, or pre-wedding photoshoots. Many operators offer tailor-made packages for such events."
  }
},
{
  "@type": "Question",
  "name": "What is the best time to book a private yacht in Goa?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "The best time to rent a private yacht in Goa is between November and February when the weather is pleasant. However, yachts are available year-round for a luxury experience on Goa's waters."
  }
},
{
  "@type": "Question",
  "name": "Can I bring my own food and drinks on a private yacht?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Some yacht operators allow you to bring your own food and beverages, while others provide catering services. It's advisable to check with the provider in advance."
  }
},
{
  "@type": "Question",
  "name": "Are private yacht rentals in Goa suitable for water sports?",
  "acceptedAnswer": {
    "@type": "Answer",
    "text": "Yes, many private yachts offer additional water sports activities such as jet skiing, snorkeling, and fishing. You can inquire about these options when booking your yacht."
  }
}



]
      }
    ]
  };
},


};


  